import { getAirbrake } from "@simplybusiness/services";
import { useMutation } from "@tanstack/react-query";
import {
  AIRBRAKE_PROJECT_ID,
  AIRBRAKE_PROJECT_KEY,
} from "../../constants/constants";
import { apiRequest } from "../../utils/apiRequest";
import { useTokensValues } from "../tokens";

const airbrake = getAirbrake({
  projectId: AIRBRAKE_PROJECT_ID,
  projectKey: AIRBRAKE_PROJECT_KEY,
});

/**
 * This hook is used to store a user's payment period
 * in Chopin using a step_action.  It is trigerred
 * when changing a Payment Period toggle.
 */
export const useTogglePaymentPreference = () => {
  const tokens = useTokensValues();

  const mutation = useMutation({
    mutationFn: (paymentPreference: string) =>
      apiRequest("?step_action=toggle_payment_preference", {
        ...tokens,
        paymentPreference,
      }),
    mutationKey: ["togglePaymentPreference"],
  });

  const { isPending, isError, error, isSuccess, mutate } = mutation;

  const togglePaymentPreference = (paymentPreference: string) => {
    mutate(paymentPreference, {
      onSuccess: () => {}, // No response to handle
      onError: (error: Error) => {
        console.error(`Error toggling payment preference: ${error.message}`);
        void airbrake.notify(error);
      },
    });
  };

  return {
    togglePaymentPreference,
    isSuccess,
    isPending,
    isError,
    error,
  };
};
